// extracted by mini-css-extract-plugin
export var completionBody = "_li-2";
export var completionCard = "_li-0";
export var completionFooter = "_li-3";
export var completionTitle = "_li-1";